import React from 'react';
import { MenuItem } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

import { SelectV2 } from '@components';
import { popoverShadow } from 'theme/shadows';

interface IGroupByMenuProps<GroupBy extends string> {
  options: { label: string; value: string }[];
  value: GroupBy;
  onChange: (groupBy: GroupBy) => void;
}

export const GroupByMenu = <GroupBy extends string>({
  options,
  value,
  onChange,
}: IGroupByMenuProps<GroupBy>) => (
  <SelectV2
    displayEmpty
    value={value}
    MenuProps={{
      PaperProps: {
        sx: (theme) => ({
          minWidth: '12rem',
          mt: 0.5,
          borderRadius: '4px',
          border: `1px solid ${theme.palette.background.divider}`,
          boxShadow: popoverShadow,
          '& .MuiList-root': { py: 0.5 },
        }),
      },
    }}
    onChange={(event) => onChange(event.target.value as GroupBy)}
    renderValue={(selectedValue) => {
      const selectedOption = options.find(
        (option) => option.value === selectedValue,
      );
      return (
        <>Group by: {selectedOption ? selectedOption.label : 'No grouping'}</>
      );
    }}
  >
    {options.map((option) => (
      <MenuItem
        key={option.value}
        value={option.value}
        sx={{
          height: '2.25rem',
          gap: 1,
          px: 1.5,
          color: option.value === value ? 'text.primary' : 'text.secondary',
          fontWeight: option.value === value ? 500 : 400,
          '&.Mui-selected, &.Mui-selected:hover': {
            backgroundColor: 'transparent',
          },
          '&:hover': { backgroundColor: 'highlight.neutral' },
        }}
      >
        <CheckIcon
          sx={{
            fontSize: '1rem',
            flexShrink: 0,
            opacity: option.value === value ? 1 : 0,
          }}
        />
        {option.label}
      </MenuItem>
    ))}
  </SelectV2>
);
